import React from "react";
import {
  Button,
  Grid,
  Paper,
  Select,
  TextField,
  Typography,
  MenuItem,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { useTranslation } from "react-i18next";
import { isNotNullOrEmptyArray } from "../../globals/utils";

const ScheduleInspectionForm = ({
  formData,
  errors,
  onChange,
  onSubmit,
  vles,
}) => {
  const { t } = useTranslation();

  return (
    <Paper
      sx={{
        padding: 3,
        maxWidth: 600,
        margin: "auto",
        paddingBottom: 10,
        mt: 2,
        mr: 2,
        ml: 2,
      }}
    >
      <Typography variant="h5" gutterBottom>
        {t("Schedule Inspection")}
      </Typography>
      <form onSubmit={onSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DateTimePicker"]}>
                <DateTimePicker
                  label={t("Visiting on")}
                  name="visiting_on"
                  value={formData.visiting_on}
                  onChange={(value) =>
                    onChange({
                      target: { name: "visiting_on", value: value },
                    })
                  }
                  error={!!errors.visiting_on}
                  helperText={errors.visiting_on}
                  required
                  fullWidth
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>
          {isNotNullOrEmptyArray(vles) && (
            <Grid item xs={12}>
              <Select
                fullWidth
                label={t("VLE")}
                name="vle"
                value={formData.vle}
                onChange={onChange}
                required
                error={!!errors.vle}
                helperText={errors.vle}
              >
                {vles.map((vle) => (
                  <MenuItem key={vle.id} value={vle.id}>
                    {vle.full_name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          )}
          <Grid item xs={12}>
            <TextField
              type="text"
              fullWidth
              label={t("Comments")}
              name="comments"
              value={formData.comments}
              onChange={onChange}
              required
              error={!!errors.comments}
              helperText={errors.comments}
            />
          </Grid>
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              {t("Submit")}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default ScheduleInspectionForm;
